/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Nature_AcuteInputs */

const en_us2_bodymap_nature_acute = /** @type {(inputs: Bodymap_Nature_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sharp, recent pain`)
};

const pt_br2_bodymap_nature_acute = /** @type {(inputs: Bodymap_Nature_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor aguda, recente`)
};

const es_419_bodymap_nature_acute = /** @type {(inputs: Bodymap_Nature_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolor agudo, reciente`)
};

const pt_pt2_bodymap_nature_acute = /** @type {(inputs: Bodymap_Nature_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor aguda, recente`)
};

const fr_fr2_bodymap_nature_acute = /** @type {(inputs: Bodymap_Nature_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douleur vive, récente`)
};

const de_de2_bodymap_nature_acute = /** @type {(inputs: Bodymap_Nature_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stechend, neu`)
};

const it_it2_bodymap_nature_acute = /** @type {(inputs: Bodymap_Nature_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolore acuto, recente`)
};

/**
* | output |
* | --- |
* | "Sharp, recent pain" |
*
* @param {Bodymap_Nature_AcuteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_nature_acute = /** @type {((inputs?: Bodymap_Nature_AcuteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Nature_AcuteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_nature_acute(inputs)
	if (locale === "es-419") return es_419_bodymap_nature_acute(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_nature_acute(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_nature_acute(inputs)
	if (locale === "de-DE") return de_de2_bodymap_nature_acute(inputs)
	if (locale === "it-IT") return it_it2_bodymap_nature_acute(inputs)
	return en_us2_bodymap_nature_acute(inputs)
});
export { bodymap_nature_acute as "bodymap.nature.acute" }